export const GET_INO_LIST = "GET_INO_LIST"; 

export const GET_INO_DETAIL = "GET_INO_DETAIL"; 

export const GET_BOXES_BY_ID = "GET_BOXES_BY_ID";

export const GET_INO_LIST_BY_ADDRESS = "GET_INO_LIST_BY_ADDRESS";

export const GET_TOTAL_OWNER_BOX = "GET_TOTAL_OWNER_BOX";
